import PropTypes from 'prop-types';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from './hook/useAuth';

function ProtectRoute({ allowedRoles = [2001] }) {
  const { auth } = useAuth();
  const location = useLocation();

  // if (auth?.accessToken) {
  //   return <Outlet />;
  // } else {
  //   return <Navigate to="/sign-in" state={{ from: location }} replace />;
  // }
  return auth?.roles?.find((role) => allowedRoles?.includes(role)) ? (
    <Outlet />
  ) : auth?.accessToken ? ( //changed from user to accessToken to persist login after refresh
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/sign-in" state={{ from: location }} replace />
  );
}

ProtectRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.number),
};

export default ProtectRoute;
